var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Datepicker',{attrs:{"valueType":_vm.valueType,"format":_vm.format,"clearable":false,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"lang":{
    days: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
    yearFormat: 'YYYY',
    monthFormat: 'MMMM',
  }},on:{"input":function($event){return _vm.$emit('input', _vm.date)}},scopedSlots:_vm._u([{key:"icon-calendar",fn:function(){return [(_vm.isHasCalendarIcon)?_c('img',{attrs:{"src":require("../../../public/custom/images/calendar.svg"),"alt":"Calendar image"}}):_c('svg')]},proxy:true}]),model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }